import React from 'react';

export const siteStructure = [
  {
    id: 1,
    title: 'Inicio',
    path: '/',
    color: '#0056b3',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    ),
    description: 'Página principal de Cursos Virtuales ICETEX con información general sobre nuestros servicios',
    links: [
      { label: 'Hero - Bienvenida', path: '/#hero' },
      { label: 'Herramientas de Autodiagnóstico', path: '/#tools' },
      { label: 'Plataforma de Formación', path: '/#education' },
      { label: 'Comunidad y Acompañamiento', path: '/#community' },
      { label: 'Recursos y Apoyo', path: '/#resources' }
    ]
  },
  {
    id: 2,
    title: 'Diagnósticos',
    path: '/diagnosticos',
    color: '#003F81',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
      </svg>
    ),
    description: 'Herramientas de autodiagnóstico para evaluar tu bienestar y proyecto de vida',
    links: [
      { label: 'Explorador de Propósito y Proyecto de Vida', path: '/diagnosticos' },
      { label: 'Mapa Personal de Bienestar Emocional', path: '/diagnosticos' },
      { label: 'Rueda de la Vida', path: '/diagnosticos' }
    ]
  },
  {
    id: 3,
    title: 'Formación',
    path: 'https://moodle.cursosvirtualesicetex.com/',
    color: '#00A551',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
      </svg>
    ),
    description: 'Plataforma Moodle con cursos, talleres y recursos educativos',
    external: true,
    links: [
      { label: 'Cursos de Bienestar', path: 'https://moodle.cursosvirtualesicetex.com/', external: true },
      { label: 'Emprendimiento', path: 'https://moodle.cursosvirtualesicetex.com/', external: true },
      { label: 'Desarrollo de Habilidades', path: 'https://moodle.cursosvirtualesicetex.com/', external: true }
    ]
  },
  {
    id: 4,
    title: 'Recursos',
    path: '/recursos',
    color: '#D32F2F',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
      </svg>
    ),
    description: 'Biblioteca de recursos, guías descargables y líneas de ayuda',
    links: [
      { label: 'Cartilla: Convivir sin Violencia', path: '/recursos' },
      { label: 'Protocolo de Diseño', path: '/recursos' },
      { label: 'Líneas de Ayuda', path: '/recursos' }
    ]
  },
  {
    id: 6,
    title: 'Acceso a Usuario',
    path: '/diagnosticos',
    color: '#7B1FA2',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
    ),
    description: 'Inicio de sesión y registro para acceder a servicios personalizados',
    links: [
      { label: 'Iniciar Sesión', path: '/diagnosticos' },
      { label: 'Registrarse', path: '/diagnosticos' },
      { label: 'Recuperar Contraseña', path: '/diagnosticos' }
    ]
  }
];

export const additionalPages = [
  {
    title: 'Políticas',
    path: 'https://web.icetex.gov.co/web/portal/el-icetex/normatividad/politicas-lineamientos-y-manuales',
    external: true
  },
  {
    title: 'Términos y Condiciones',
    path: '/terminos-y-condiciones'
  }
];

